export const allowedCollections = [
  'payment',
  'organization',
  'fundingSource',
  'deliveryMethod',
  'user',
  'bill',
  'voidCheck'
];

export const collectionDisplayEmoji = {
  payment: '💵',
  organization: '🏢',
  fundingSource: '📤',
  deliveryMethod: '📥',
  user: '👩‍🏭',
  bill: '🧾',
  voidCheck: '💬'
};
